import getTargettedTabIndex from './getTargettedTabIndex';
import selectTab from './selectTab';

/**
 * Selects and focuses the tab before targettedTab within listOfTabs.
 * @param   {Object}   targettedTab    the currently focussed tab.
 * @param   {NodeList} listOfTabs      the NodeList containing targettedTab.
 * @param   {NodeList} listOfTabPanels the NodeList of tab panels corresponding
 * to the tabs in listOfTabs.
 */
const selectPreviousTab = (targettedTab, listOfTabs, listOfTabPanels) => {
  const targettedTabIndex = getTargettedTabIndex(targettedTab, listOfTabs);
  if (targettedTabIndex === 0) {
    selectTab(listOfTabs[listOfTabs.length - 1], listOfTabs, listOfTabPanels);
  } else if (targettedTabIndex !== -1) {
    selectTab(listOfTabs[targettedTabIndex - 1], listOfTabs, listOfTabPanels);
  }
};

export default selectPreviousTab;
